<script setup lang="ts">
const productContent = useProductContentStore()

const personalization = usePersonalizationStore()

async function handleNextArticleClick() {
  if (
    productContent.activeArticle?.id &&
    productContent.nextArticle?.frontendHref
  ) {
    personalization.addArticleToReadHistory(
      productContent.activeArticle.id,
      true,
    )
    await navigateTo(productContent.nextArticle.frontendHref)
  }
}
</script>

<template>
  <div
    class="flex items-center justify-between px-6 md:justify-start md:px-0"
  >
    <UContentFreeLabel
      v-if="productContent.activeSubject?.showFreeLabel"
      class="md:hidden"
    />
    <UButton
      v-if="productContent.nextArticle?.id"
      pill
      theme="light"
      class="md:mr-6"
      @click="handleNextArticleClick"
    >
      <template #prepend>
        <UIcon name="arrow-down" />
      </template>
      Neste
    </UButton>
    <span
      class="hidden grow truncate whitespace-nowrap text-button-medium-button-text-regular md:block"
    >
      {{ productContent.nextArticle?.title }}</span>
    <UContentFreeLabel
      v-if="productContent.activeSubject?.showFreeLabel"
      class="hidden md:block"
    />
  </div>
</template>
